export default __webpack_public_path__ + "c8c9b73e57fe0791bb71b07d2b371f26.png";